export default {
    name: 'QList',
    props: {
        items: {
            type: [String, Array, Object],
            default: null
        },
        hasRightArrow: {
            type: Boolean,
            default: false
        }
    },
    beforeMount() {
        this.formatItems();
    },
    updated() {
        this.formatItems();
    },
    methods: {
        formatItems() {
            if (typeof this.items === 'string') {
                this.items = [this.items];
            }
        }
    }
};
